import { ApiResponse, getApiService } from '@/services/api';
import { Contact } from '@/shared/model/contact';

const CONTACT_PATH = '/contact';

export class ContactApi {
  private static getApiInstance() {
    return getApiService();
  }

  static async getByPersonId(personId: string): Promise<ApiResponse<Contact[]>> {
    const apiService = this.getApiInstance();
    return await apiService.client.get(`${CONTACT_PATH}/person/${personId}`);
  }

  static async addForPerson(personId: string, data: Omit<Contact, 'id'>): Promise<ApiResponse<Contact>> {
    const apiService = this.getApiInstance();
    return await apiService.client.post(`${CONTACT_PATH}/person/${personId}`, data);
  }

  static async update(contactId: string, data: Contact): Promise<ApiResponse<Contact>> {
    const apiService = this.getApiInstance();
    return await apiService.client.put(`${CONTACT_PATH}/${contactId}`, data);
  }

  static async delete(contactId: string): Promise<ApiResponse<void>> {
    const apiService = this.getApiInstance();
    return await apiService.client.delete(`${CONTACT_PATH}/${contactId}`);
  }
}
